/** Vue une fois sur l’écran connexion / inscription (PC, mobile, PWA). */
const SIGNUP_POPIN_KEY = 'dl_magic_movie_popin_signup_seen_v1';

export function hasSeenAuthPopin(): boolean {
  return hasSeenSignupPopin();
}

export function markAuthPopinSeen(): void {
  markSignupPopinSeen();
}

export function hasSeenSignupPopin(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    return localStorage.getItem(SIGNUP_POPIN_KEY) === '1';
  } catch {
    return false;
  }
}

export function markSignupPopinSeen(): void {
  if (typeof window === 'undefined') return;
  try {
    localStorage.setItem(SIGNUP_POPIN_KEY, '1');
  } catch {
    /* ignore */
  }
}

/** Après l’intro vidéo PWA → forcer la popin une fois sur la page inscription. */
export function setPendingSignupPopinAfterIntro(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem('dl_magic_movie_popin_after_intro', '1');
  } catch {
    /* ignore */
  }
}

export function consumePendingSignupPopinAfterIntro(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    if (sessionStorage.getItem('dl_magic_movie_popin_after_intro') !== '1') return false;
    sessionStorage.removeItem('dl_magic_movie_popin_after_intro');
    return true;
  } catch {
    return false;
  }
}

const REPURCHASE_POPIN_SESSION_KEY = 'dl_magic_movie_popin_repurchase_dismissed';

/** Popin avant l’écran packs (crédits épuisés), une fois par session navigateur. */
export function isRepurchasePopinDismissedThisSession(): boolean {
  if (typeof window === 'undefined') return true;
  try {
    return sessionStorage.getItem(REPURCHASE_POPIN_SESSION_KEY) === '1';
  } catch {
    return false;
  }
}

export function markRepurchasePopinDismissedThisSession(): void {
  if (typeof window === 'undefined') return;
  try {
    sessionStorage.setItem(REPURCHASE_POPIN_SESSION_KEY, '1');
  } catch {
    /* ignore */
  }
}
